import { useEffect, useState } from "react";

const STEPS = [
  "Pulling his exposure profile",
  "Matching the wash to his routine",
  "Activating your 60-day guarantee",
  "Loading his page",
];

/**
 * Funnel-exit loader before the PDP hand-off, on the same approved tick
 * chassis as the sibling quiz's ApplyingPage (`.qk-manly-lrow` in the shared
 * base stylesheet) so the funnel's two loaders read as one system.
 *
 * Deliberately DISCOUNT-FREE, unlike the sibling: this funnel promises no
 * discount and lands on the real PDP, so every string here reflects work on
 * HIS profile and HIS wash, never an offer being applied. The guarantee step
 * is fair game: OFFER.guarantee is a real term of the product page.
 *
 * Owns its timers per the sibling's contract: every step timer AND the final
 * onDone timer are scheduled up front at fixed absolute offsets, and all are
 * cleared on unmount.
 */
export function ApplyingPage({ onDone, durationMs = 3400 }: { onDone: () => void; durationMs?: number }) {
  // How many steps have been reached. 0 = first step active; STEPS.length = all done.
  const [active, setActive] = useState(0);

  useEffect(() => {
    const stepMs = durationMs / (STEPS.length + 1);
    const timers = STEPS.map((_, i) =>
      window.setTimeout(() => setActive(i + 1), Math.round((i + 1) * stepMs)),
    );
    timers.push(window.setTimeout(onDone, durationMs));
    return () => timers.forEach((t) => clearTimeout(t));
  }, [onDone, durationMs]);

  return (
    <div className="qk-manly-loader" role="status" aria-live="polite">
      <h2>Taking you to his wash…</h2>
      <p className="qk-manly-loader-lead">Bringing up the bottle that passed all three checks.</p>

      <ol className="qk-manly-loader-rows">
        {STEPS.map((label, i) => {
          const state = active > i ? "done" : active === i ? "active" : "pending";
          return (
            <li key={label} className={`qk-manly-lrow is-${state}`}>
              <span className="qk-manly-tick" aria-hidden="true">{state === "done" ? "✓" : ""}</span>
              <span>{label}</span>
            </li>
          );
        })}
      </ol>

      <p className="qk-manly-loader-foot">Please don't refresh</p>
    </div>
  );
}
